<div class="membershipTableDiv mx-3 mb-3">

<div class="row row justify-content-center">
  <div class="col-10 mt-3 mr-5">
    <h2 class="mx-2">{{mainHeader}}</h2>
  </div>
  <div class="d-flex justify-content-end align-items-center col-2">
    <button mat-icon-button [mat-dialog-close]="'close'"><mat-icon>close</mat-icon></button>
  </div>
</div>
  <section class="example-container mat-elevation-z8 m-2" tabindex="0">
    <table mat-table [dataSource]="rows" matSort>

      @for(column of displayedColumns; track column; let i = $index) {
        <ng-container [matColumnDef]="column" *ngIf="column!=='status'">
          <th class="m-1 p-3" mat-header-cell *matHeaderCellDef> {{header[i] }} </th>
          <td class="m-1 p3" mat-cell *matCellDef="let element"> {{column=='price' ? "$" : ""}}{{element[column]}} </td>
        </ng-container>
        <ng-container [matColumnDef]="column" *ngIf="column=='status'">
          <th class="m-1 p-3" mat-header-cell *matHeaderCellDef> {{header[i]}} </th>
          <td class="m-1 p3" mat-cell *matCellDef="let element">
            @if(element?.usedOnlineEntryPaymentService == false) {
              <span class="completed-status">N/A</span>
            } @else if(this.whoPay == 'Parent' && element.paymentStatus == 'pending_payment') {
              @if(addedToCartIds().includes(element.entryId) || references().includes(element.entryId)) {
                <div>Successfully added to your cart</div>
              } @else if(isPaymentEnable(element)) {
                <button mat-raised-button color="primary" class="make-payment-button" (click)="payRiderFees(element)">Payment Due</button>
              } @else {
                <span class="incomplete-status">Pending</span>
              }
            } @else {
              @switch (element.paymentStatus) {
                @case ('pending_payment') {
                  <span class="incomplete-status">Pending</span>
                }
                @case ('captured') {
                  <span class="completed-status">Paid</span>
                }
                @case ('authorized') {
                  <span class="completed-status">Paid</span>
                }
                @default {
                  <span class="completed-status">{{element.paymentStatus}}</span>
                }
              }
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>

  </section>
  @if(addedToCartIds().length) {
    <div class="action-section">
      <button mat-raised-button color="primary" class="make-payment-button" (click)="goToCart()">Go to cart</button>
    </div>
  }
</div>
